import React from "react";
import TermsAndConditions from "@/components/Pages/Public/TermsAndConditions";

const TermsAndConditionsPage: React.FC = () => {
  return <TermsAndConditions />;
};

export default TermsAndConditionsPage;
